import "./customercreate.css"
function CustomerCreate(){
    return(
        <>
        <div className="customercreate">
             <div className="start">
                       <h4>Customers Create </h4>
                       <div className="point">
                           <div></div>
                           <div></div>
                           <div></div>
                       </div>
            </div>
           <div className="row">
  <div className="col-md-6">
    <div className="card p-4 shadow-sm">

      {/* Header */}
      <div className="mb-4">
        <h5 className="fw-bold">Personal Information</h5>
        <small >
          The following information will be publicly displayed. Please be careful.
        </small>
      </div>

      {/* Avatar */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-image me-3 text-primary"></i>
        <div>
          <h6 className="mb-0">Avatar</h6>
          <small >profile.jpg</small>
        </div>
      </div>

      {/* Name */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-user me-3 text-success"></i>
        <div>
          <h6 className="mb-0">Name</h6>
          <small >Alexandra Della</small>
        </div>
      </div>

      {/* Email */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-envelope me-3 text-danger"></i>
        <div>
          <h6 className="mb-0">Email</h6>
          <small >alex@example.com</small>
        </div>
      </div>

      {/* Username */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-at me-3 text-warning"></i>
        <div>
          <h6 className="mb-0">Username</h6>
          <small >@alexdella</small>
        </div>
      </div>

      {/* Phone */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-phone me-3 text-info"></i>
        <div>
          <h6 className="mb-0">Phone</h6>
          <small >+1 234 567 890</small>
        </div>
      </div>

      {/* Company */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-building me-3 text-secondary"></i>
        <div>
          <h6 className="mb-0">Company</h6>
          <small >Ocean Tech</small>
        </div>
      </div>

      {/* Website */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-globe me-3 text-primary"></i>
        <div>
          <h6 className="mb-0">Website</h6>
          <small >www.oceantech.com</small>
        </div>
      </div>

      {/* Designation */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-briefcase me-3 text-dark"></i>
        <div>
          <h6 className="mb-0">Designation</h6>
          <small >Front-End Developer</small>
        </div>
      </div>

      {/* VAT */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-receipt me-3 text-warning"></i>
        <div>
          <h6 className="mb-0">VAT Number</h6>
          <small >123456789</small>
        </div>
      </div>

      {/* Address */}
      <div className="d-flex align-items-center mb-3">
        <i className="fa-solid fa-location-dot me-3 text-danger"></i>
        <div>
          <h6 className="mb-0">Address</h6>
          <small >New York, USA</small>
        </div>
      </div>

      {/* About */}
      <div className="d-flex align-items-start">
        <i className="fa-solid fa-circle-info me-3 text-info mt-1"></i>
        <div>
          <h6 className="mb-0">About</h6>
          <small >
            Passionate front-end developer with experience in React and modern UI design.
          </small>
        </div>
      </div>

    </div>
  </div>
  <div className="col-md-6">
  <div className="card p-4 shadow-sm">

    {/* Header */}
    <div className="mb-4">
      <h5 className="fw-bold">Additional Information</h5>
      <small >
        Manage your personal and account-related details.
      </small>
    </div>

    {/* Date of Birth */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-cake-candles me-3 text-danger"></i>
      <div>
        <h6 className="mb-0">Date of Birth</h6>
        <small >15 March 1998</small>
      </div>
    </div>

    {/* Country */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-flag me-3 text-primary"></i>
      <div>
        <h6 className="mb-0">Country</h6>
        <small >Egypt</small>
      </div>
    </div>

    {/* City */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-city me-3 text-secondary"></i>
      <div>
        <h6 className="mb-0">City</h6>
        <small >Cairo</small>
      </div>
    </div>

    {/* Time Zone */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-clock me-3 text-warning"></i>
      <div>
        <h6 className="mb-0">Time Zone</h6>
        <small >GMT +2</small>
      </div>
    </div>

    {/* Language */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-language me-3 text-info"></i>
      <div>
        <h6 className="mb-0">Language</h6>
        <small >English</small>
        <br />
        <small >Germany</small>
        <br />
        <small >Spanish</small>

      </div>
    </div>

    {/* Group */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-users me-3 text-success"></i>
      <div>
        <h6 className="mb-0">Group</h6>
        <small >Admin</small>
      </div>
    </div>

    {/* Status */}
    <div className="d-flex align-items-center mb-3">
      <i className="fa-solid fa-toggle-on me-3 text-success"></i>
      <div>
        <h6 className="mb-0">Status</h6>
        <small >Active</small>
      </div>
    </div>

    {/* Privacy */}
    <div className="d-flex align-items-center">
      <i className="fa-solid fa-lock me-3 text-dark"></i>
      <div>
        <h6 className="mb-0">Privacy</h6>
        <small >Public Profile</small>
      </div>
    </div>

  </div>
</div>
<div className="col-md-6">
  <div className="card p-4 shadow-sm">

    {/* Header */}
    <div className="mb-4">
      <h5 className="fw-bold">Password Information</h5>
      <small >
        Make sure your password is strong and secure.
      </small>
    </div>

    {/* Password */}
    <div className="mb-3">
      <label className="form-label">
        <i className="fa-solid fa-lock me-2 text-primary"></i>
        Password
      </label>
      <input
        type="password"
        className="form-control"
        placeholder="Enter new password"
      />
    </div>

    {/* Confirm Password */}
    <div className="mb-3">
      <label className="form-label">
        <i className="fa-solid fa-lock me-2 text-success"></i>
        Confirm Password
      </label>
      <input
        type="password"
        className="form-control"
        placeholder="Confirm your password"
      />
    </div>

    {/* Password Requirements */}
    <div className="mt-4">
      <h6 className="mb-2">
        <i className="fa-solid fa-shield-halved me-2 text-danger"></i>
        Password Requirements
      </h6>

      <ul className="small text-muted ps-3">
        <li>At least 8 characters</li>
        <li>Include at least one uppercase letter</li>
        <li>Include at least one lowercase letter</li>
        <li>Include at least one number</li>
        <li>Include at least one special character</li>
      </ul>
    </div>

    {/* Button */}
    <div className="mt-4">
      <button className="btn btn-primary w-100">
        Update Password
      </button>
    </div>

  </div>
</div>
<div className="col-md-6">
  <div className="card p-4 shadow-sm">

    {/* Header */}
    <div className="mb-4">
      <h5 className="fw-bold">Security Preferences</h5>
      <small >
        Manage your account security settings.
      </small>
    </div>

    {/* Two-Step Authentication */}
    <div className="d-flex align-items-center justify-content-between mb-4">
      <div>
        <h6 className="mb-1">
          <i className="fa-solid fa-shield-halved me-2 text-primary"></i>
          Enable Two-Step Authentication
        </h6>
        <small >
          Add an extra layer of security to your account.
        </small>
      </div>

      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id="twoStepSwitch"
        />
      </div>
    </div>

    {/* Change Password Every 6 Months */}
    <div className="d-flex align-items-center justify-content-between">
      <div>
        <h6 className="mb-1">
          <i className="fa-solid fa-key me-2 text-warning"></i>
          Require Password Change Every 6 Months
        </h6>
        <small >
          Force password updates regularly for better protection.
        </small>
      </div>

      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id="passwordChangeSwitch"
        />
      </div>
    </div>

  </div>
</div>
{/* Shipping Address */}
<div className="col-md-6">
  <div className="card p-4 shadow-sm">

    <div className="mb-4">
      <h5 className="fw-bold">Shipping Address</h5>
      <small >Provide your shipping details.</small>
    </div>

    {/* Address */}
    <div className="mb-3">
      <label className="form-label">Address</label>
      <input type="text" className="form-control" placeholder="Street address" />
    </div>

    {/* Zip Code */}
    <div className="mb-3">
      <label className="form-label">Zip Code</label>
      <input type="text" className="form-control" placeholder="Zip / Postal code" />
    </div>

    {/* Country */}
    <div className="mb-3">
      <label className="form-label">Country</label>
      <input type="text" className="form-control" placeholder="Country" />
    </div>

    {/* State */}
    <div className="mb-3">
      <label className="form-label">State</label>
      <input type="text" className="form-control" placeholder="State" />
    </div>

    {/* City */}
    <div className="mb-3">
      <label className="form-label">City</label>
      <input type="text" className="form-control" placeholder="City" />
    </div>

  </div>
</div>

{/* Billing Address */}
<div className="col-md-6">
  <div className="card p-4 shadow-sm">

    <div className="mb-4">
      <h5 className="fw-bold">Billing Address</h5>
      <small >Provide your billing details.</small>
    </div>

    {/* Address */}
    <div className="mb-3">
      <label className="form-label">Address</label>
      <input type="text" className="form-control" placeholder="Street address" />
    </div>

    {/* Zip Code */}
    <div className="mb-3">
      <label className="form-label">Zip Code</label>
      <input type="text" className="form-control" placeholder="Zip / Postal code" />
    </div>

    {/* State */}
    <div className="mb-3">
      <label className="form-label">State</label>
      <input type="text" className="form-control" placeholder="State" />
    </div>

    {/* City */}
    <div className="mb-3">
      <label className="form-label">City</label>
      <input type="text" className="form-control" placeholder="City" />
    </div>

    {/* Status */}
    <div className="mb-3">
      <label className="form-label">Status</label>
      <select className="form-select">
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>

  </div>
</div>
<div className="col-md-12">
  <div className="card p-4 shadow-sm">

    {/* Header */}
    <div className="mb-4">
      <h5 className="fw-bold">Development Connections</h5>
      <small >
        Connect your development and social accounts for integration.
      </small>
    </div>

    {/* Connections List */}
    <div className="d-flex flex-wrap gap-3">

      {/* Google Drive */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-google-drive fs-4 text-danger me-2"></i>
        <span>Google Drive</span>
      </div>

      {/* Dropbox */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-dropbox fs-4 text-primary me-2"></i>
        <span>Dropbox</span>
      </div>

      {/* GitHub */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-github fs-4 text-dark me-2"></i>
        <span>GitHub</span>
      </div>

      {/* GitLab */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-gitlab fs-4 text-warning me-2"></i>
        <span>GitLab</span>
      </div>

      {/* WhatsApp */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-whatsapp fs-4 text-success me-2"></i>
        <span>WhatsApp</span>
      </div>

      {/* Shopify */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-shopify fs-4 text-success me-2"></i>
        <span>Shopify</span>
      </div>

      {/* Instagram */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-instagram fs-4 text-danger me-2"></i>
        <span>Instagram</span>
      </div>

      {/* LinkedIn */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-linkedin fs-4 text-primary me-2"></i>
        <span>LinkedIn</span>
      </div>

    </div>

  </div>
</div>
<div className="col-md-12">
  <div className="card p-4 shadow-sm">

    {/* Header */}
    <div className="mb-4">
      <h5 className="fw-bold">Social Connections</h5>
      <small >
        Connect your social accounts for profile integration.
      </small>
    </div>

    {/* Connections List */}
    <div className="d-flex flex-wrap gap-3">

      {/* Facebook */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-facebook fs-4 text-primary me-2"></i>
        <span>Facebook</span>
      </div>

      {/* Twitter */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-twitter fs-4 text-info me-2"></i>
        <span>Twitter</span>
      </div>

      {/* Instagram */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-instagram fs-4 text-danger me-2"></i>
        <span>Instagram</span>
      </div>

      {/* LinkedIn */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-linkedin fs-4 text-primary me-2"></i>
        <span>LinkedIn</span>
      </div>

      {/* YouTube */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-youtube fs-4 text-danger me-2"></i>
        <span>YouTube</span>
      </div>

      {/* WhatsApp */}
      <div className="d-flex align-items-center border rounded p-2 flex-grow-1">
        <i className="fa-brands fa-whatsapp fs-4 text-success me-2"></i>
        <span>WhatsApp</span>
      </div>

    </div>

  </div>
</div>





</div>


        </div>
        </>
    )
}
export default CustomerCreate